import { AIResponse, AITaskResponse } from '@honeybook/ai-core';
import { builderFor } from 'ts-byob';
import { faker } from '@faker-js/faker';
import { IHBError } from '@honeybook/ai-core/types/server-types';

export const aTestAITaskResponse = builderFor<AITaskResponse>(() => {
    const aiTaskId = faker.string.uuid();

    return {
        ai_task_id: aiTaskId,
        feature: '',
        status: 'active',
        responses: [],
        protocol: {
            type: 'test',
            data: { ai_task_id: aiTaskId }
        }
    };
});

// Content builders for different response types
export const anActionContent = builderFor(() => {
    return {
        type: 'navigation' as const,
        data: {
            destination: '/test'
        }
    };
});

export const aStructuredContent = builderFor(() => {
    return {
        type: 'flow_template_creation',
        data: {
            flow_type: 'flow_template'
        }
    };
});

export const aMarkdownContent = builderFor<string>(() => {
    return faker.lorem.sentence();
});

export const aDoneContent = builderFor<{
    message_id: string;
    message_created_at: string;
}>(() => {
    return {
        message_created_at: faker.date.recent().toISOString(),
        message_id: faker.string.uuid()
    };
});

export const anErrorContent = builderFor<IHBError>(() => {
    return {
        error_data: {},
        error_message: 'Test error occurred',
        error_type: 'PROCESSING_ERROR',
        is_timeout: false
    };
});

// Main response builder that works with content builders
export const anAIResponse = builderFor<AIResponse>(() => {
    return {
        uid: faker.string.uuid(),
        order: 0,
        status: 'ready',
        type: 'markdown',
        content: aMarkdownContent()
    };
});

// Convenience builders for common response types
export const aCompletedAIResponse = builderFor<AIResponse>(() => {
    return {
        uid: faker.string.uuid(),
        status: 'ready',
        type: 'done',
        order: 0,
        content: aDoneContent()
    };
});

export const anErrorAIResponse = builderFor<AIResponse>(() => {
    return {
        uid: faker.string.uuid(),
        status: 'ready',
        type: 'error',
        order: 0,
        content: anErrorContent()
    };
});
